import { Typography } from '@mui/material';
import { useUser } from '../../Hooks/useUser';
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout';
import { AccountInfoSkeleton } from './Components/AccountInfo/AccountInfoSkeleton';
import { ViewAccountInfo } from './Components/AccountInfo/ViewAccountInfo';

export const AccountInfo = () => {
    /* ******************** Hooks ******************** */    
    const { user, isUserLoading, isUserFetching } = useUser();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <KaziLayout
            >
                <Typography variant="lora-headline-small">Account info</Typography>
                {
                    isUserLoading || isUserFetching ?
                    <AccountInfoSkeleton />
                    :
                    <ViewAccountInfo 
                        user={user}
                    />
                }
            </KaziLayout>
        </>
    )
}